export class LoginModel {
  userName: string;
  password: string;

  constructor(userName: string, password: string) {
    this.userName = userName;
    this.password = password;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/login/models/login.model.ts